import {
  Grid,
  Box,
  TextField,
  Button,
  Switch,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { useState } from "react";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import { EditorCkMain } from "../../components/CkEditor";
import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

export const JOB_TYPES = [
  { value: "full_time", label: "Full time" },
  { value: "part_time", label: "Part time" },
  { value: "internship", label: "Internship" },
  { value: "contract", label: "Contract" },
];
export const WORK_TYPES = [
  { value: "remote", label: "Remote" },
  { value: "location", label: "On-site" },
  { value: "hybrid", label: "Hybrid" },
];

export const AddJob = () => {
  const classes = useAdminStyles();
  const navigate = useNavigate();
  const toast = useToast();

  const [title, setTitle] = useState("");
  const [jobType, setJobType] = useState("full_time");
  const [workType, setWorkType] = useState("location");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(true);
  const [err, setErr] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = () => {
    setErr(0);
    if (!title.trim()) {
      setErr(1);
      toast.error("Please enter a job title.");
      return;
    }
    if (!description || !description.trim()) {
      setErr(2);
      toast.error("Please enter the job description.");
      return;
    }
    setSubmitting(true);
    const fd = new FormData();
    fd.append("title", title.trim());
    fd.append("job_type", jobType);
    fd.append("work_type", workType);
    fd.append("location", location.trim());
    fd.append("description", description);
    fd.append("status", status ? "show" : "hide");
    Axios.post("/api/admin/add_job", fd, { headers: { headKey } })
      .then((res) => {
        setSubmitting(false);
        if (res.data.status) {
          toast.success(res.data.msg || "Job added");
          navigate("/dash/alljobs");
        } else {
          toast.error(res.data.msg || "Something went wrong.");
        }
      })
      .catch(() => {
        setSubmitting(false);
        toast.error("Network error. Please try again.");
      });
  };

  return (
    <div>
      <Helmet>
        <title>Add Job - Admin | Arawinz Soft Solutions</title>
      </Helmet>
      <AdminPageHeader
        eyebrow="Jobs"
        title="Add new job"
        subtitle="Post a new opening to the careers page."
        backTo="/dash/alljobs"
      />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Job title"
            variant="outlined"
            error={err === 1}
            value={title}
            size="small"
            onChange={(e) => setTitle(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            placeholder="e.g. Full Stack Developer"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            label="Job type"
            variant="outlined"
            value={jobType}
            size="small"
            onChange={(e) => setJobType(e.target.value)}
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          >
            {JOB_TYPES.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            label="Work type"
            variant="outlined"
            value={workType}
            size="small"
            onChange={(e) => setWorkType(e.target.value)}
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          >
            {WORK_TYPES.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Location"
            variant="outlined"
            value={location}
            size="small"
            onChange={(e) => setLocation(e.target.value)}
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            placeholder="e.g. Hyderabad, or Remote"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box className={classes.statusRow}>
            <Switch
              checked={status}
              onChange={() => setStatus(!status)}
              color="primary"
            />
            <span>
              Status:{" "}
              <span className={status ? "on" : "off"}>
                {status ? "Shown" : "Hidden"}
              </span>
            </span>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.sectionTitle}>Description</Typography>
          <EditorCkMain desc={description} setDescr={(e) => setDescription(e)} />
        </Grid>
      </Grid>

      <Box className={classes.formFooter}>
        <Button
          className={classes.secondaryBtn}
          onClick={() => navigate("/dash/alljobs")}
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          disabled={submitting}
          className={classes.primaryBtn}
          endIcon={!submitting && <ArrowForwardIcon />}
        >
          {submitting ? "Adding..." : "Add Job"}
        </Button>
      </Box>
    </div>
  );
};
